import { createAction } from 'redux-starter-kit';
import usersApi from 'api/resources/user';
export const SET_ADVISOR = 'set-advisor';

const setAdvsior = createAction(SET_ADVISOR);

export const AdvisorActions = {
  setAdvsior,
  getAdvisor: () => (dispatch: any) => {
    return usersApi.getUserProfile().then(user => {
      dispatch(setAdvsior(user.data));
      return user.data;
    });
  }
};
